export const ISSUE_TYPE = {
  REPORT_ISSUE: "I'm Blocked",
  SUGGEST_IMPROVEMENT: 'Suggest Improvement',
} as const;

export type IssueType = (typeof ISSUE_TYPE)[keyof typeof ISSUE_TYPE];

export enum AboutType {
  PATIENT_HISTORY = 'Patient history, priors, and reason for scan',
  ORGANS = 'Organs, findings, and outputs',
  KEY_IMAGES = 'Key images (KI)',
  FINAL_IMPRESSIONS = 'Final impressions',
  REPORT_PREVIEW = 'Report preview and signature',
  SECURITY = 'Security and privacy',
  GENERAL_SYSTEM_USABILITY = 'General system usability',
  OTHER = 'Other',
}

export type CommonStyles = {
  input: string;
  select: {
    content: { root: string };
    trigger: string;
  };
};

export type IssueTypeOption = {
  value: IssueType;
};

export type AboutTypeOption = {
  value: AboutType;
};

type DescriptionGuide = {
  items: string[];
  title: string;
};

export type DescriptionGuides = {
  [key: string]: DescriptionGuide;
};

export interface ReportIssueHandlerState {
  aboutType?: AboutType;
  attachedFiles: File[];
  description: string;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: () => void;
  isReportIssueError: boolean;
  isReportIssuePending: boolean;
  isReportIssueSuccess: boolean;
  isReportServiceDeskIssueError: boolean;
  isReportServiceDeskIssuePending: boolean;
  isReportServiceDeskIssueSuccess: boolean;
  issueType?: IssueType;
  removeFile: (index: number) => void;
  resetForm: () => void;
  resetReportIssue: () => void;
  resetReportServiceDeskIssue: () => void;
  setAboutType: (value?: AboutType) => void;
  setDescription: (value: string) => void;
  setIssueType: (value?: IssueType) => void;
  setShowErrors: (value: boolean) => void;
  setTitle: (value: string) => void;
  showErrors: boolean;
  title: string;
}
